// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__35zPS","footer":"Form_footer__6q-Zy"};